import { API_URL } from 'settings';
import apiCaller from 'services/Api/ApiCaller';

export type PriceGraphPeriod =
  | 'one_day'
  | 'five_days'
  | 'one_month'
  | 'six_months'
  | 'one_year'
  | 'three_years';

export type OptionIndicatorHistory = {
  underlying_asset_id: number;
  underlying_kind: 'EQUITY' | 'BOND';
  metric: 'implied_volatility' | 'basis_points';
  period: PriceGraphPeriod;
  points: { timestamp: string; value: string }[];
};

type FetchOptionIndicatorHistory = {
  underlyingAssetId: number;
  sessionId: number;
  period: PriceGraphPeriod;
};

export const fetchOptionIndicatorHistory = async ({
  underlyingAssetId,
  sessionId,
  period,
}: FetchOptionIndicatorHistory): Promise<OptionIndicatorHistory> => {
  const { result, status } = await apiCaller({
    apiUrl: API_URL,
    path: '/underlying_assets/:underlying_asset_id/retrieve_option_indicator_history',
    method: 'GET',
    data: {
      underlying_asset_id: underlyingAssetId,
      session_id: sessionId,
      period,
    },
  });

  if (status < 200 || status >= 300) {
    throw new Error('Unable to retrieve Simplified Option indicator history.');
  }
  return result as OptionIndicatorHistory;
};
